import { applyPasswordPageRouting } from "../UserProfile/ApplyPassword";
import { integrationCredentialsRouting } from "../IntegrationCredentials/OverviewPage";
import { localize } from "client_legacy/ndaw/culture";
import { userProfileRouting } from "../UserProfile/UserProfilePage";
import { ItemModel } from "./structure";
import { SettingsPageKind } from "client/Api/SettingsLayout/settingsLayout";

export const userSettings: readonly ItemModel[] = [
	{
		id: SettingsPageKind.UserProfile,
		kind: "link",
		name: localize("_UserProfile"),
		navigation: userProfileRouting.page,
	},
	{
		id: SettingsPageKind.ApplyPassword,
		kind: "link",
		name: localize("_ApplyPassword"),
		navigation: applyPasswordPageRouting.page
	},
	{
		id: SettingsPageKind.IntegrationCredentials,
		kind: "link",
		name: localize("_IntegrationCredentials"),
		navigation: integrationCredentialsRouting.overview
	}
];